import Vue from 'vue';
import App from './container/App.vue';
import store from './store/index'; // 引入 Vuex store
import IntersectionObserverManager from './utils/ioManager';
import PageViewTracker from './utils/pageView';
// Weirwood监控
import {initVueWeirwood} from '@baidu/map-fe-utils';
import WeirwoodJson from './weirwood.json';
import {Toast, TitleBar, List} from '@baidu/onemap-design';

import './handleNaError';
import CSSThemeManager from '@baidu/css-theme-manager';
const mapThemeManager = new CSSThemeManager({
    autoDark: true
});

// 主题切换,更新store中的is_dark
mapThemeManager && mapThemeManager.on('themeChange', theme => {
    const themeDark = theme === 'dark';
    if (store.state.is_dark !== themeDark) {
        store.commit('setIsDark', themeDark);
    }
});

if (process.env.NODE_ENV === 'production') {
    initVueWeirwood(Vue, WeirwoodJson);
}

Toast.install(Vue);
TitleBar.install(Vue);
List.install(Vue);

// 公共样式文件
import '@/common/style/index.less';

Vue.config.productionTip = false;
Vue.config.ignoredElements = ['wx-open-launch-app'];
Vue.prototype.$bus = new Vue(); // EventBus
Vue.prototype.$io = new IntersectionObserverManager(); // 交叉观察器
Vue.prototype.$pageView = new PageViewTracker(); // 浏览统计

new Vue({
    store, // 将 store 传递给 Vue 实例
    render: h => h(App)
}).$mount('#app');
